<template>
  <div>
    <div class="summary">
      <div class="content">
        <h4>Change Summary</h4>
        <environmentSaveWarning />
        <commitData
          @setIsFormValid="(event) => $emit('setIsFormValid', event)"
          @setTitle="(event) => $emit('setTitle', event)"
          @setDetails="(event) => $emit('setDetails', event)"
        />
        <updatedValuesSummary :clientInfoRuleId="id" />
      </div>
    </div>
  </div>
</template>
  
<script>
import commitData from "@/components/commit-data";
import environmentSaveWarning from "@/components/environment-save-warning";
import updatedValuesSummary from "@/components/updated-values-summary";

export default {
  components: {
    commitData,
    environmentSaveWarning,
    updatedValuesSummary,
  },
  data() {
    return {
      isFormValid: false,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
};
</script>
  
<style lang="scss" scoped>
.summary {
  $subheader-height: 80px;
}
.content {
  padding: $qvo-spacing-24;
  max-width: 960px;
  margin: auto;
}
.commit-data {
  margin-top: $qvo-spacing-24;
}
</style>